import React from 'react';
import { cn } from '../../lib/utils';

export const Subtitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(({ children, className, ...props }, ref) => {
    return (
        <h1 className={cn('text-primar text-xl', className)} ref={ref} {...props}>
            {children}
        </h1>
    );
});
